import { plainToClass } from "class-transformer";
import { PromotickToken } from "src/domains/wellbeing/models/token";
import { WellbeingTokenResponse } from "src/domains/wellbeing/types";
import { DayjsUtils } from "src/libs/dayjs-utils";

class PromotickTokenMapping {
    static jsonToToken(json: WellbeingTokenResponse | Record<string, any>) {
        return plainToClass(PromotickToken, {
            token: json.token,
            expiration: DayjsUtils.getDate(json.exp).toDate(),
        });
    }
}

export { PromotickTokenMapping };
